class MobileProductGallery extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.indicators = this.els.indicator
  }

  setupListeners () {
    super.setupListeners()
    this.slides = this.els.slide

    if (!this.slides || !this.slides.exists) {
      return
    }

    this.slides.elements.forEach((slide, index) => {
      const observer = new IntersectionObserver(
        (entries) => {
          const entry = entries[0]

          if (entry.isIntersecting) {
            this.updateIndex(index)
          }
        },
        { threshold: 0.5 },
      )

      observer.observe(slide)
    })
  }

  updateIndex (activeIndex) {
    if (!this.indicators.exists) {
      return
    }

    this.indicators.elements.forEach((el) => {
      el.removeAttribute('aria-current')

      if (Number(el.dataset.index) === activeIndex) {
        el.setAttribute('aria-current', true)
      }
    })
  }
}

if (!customElements.get('mobile-product-gallery')) {
  customElements.define('mobile-product-gallery', MobileProductGallery)
}
